import {
  FilterScopeProvider,
  PITCH_POSITION_KEYS,
  ResetAllFiltersButton,
  TeamPageFilters,
} from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { useTranslation } from 'react-i18next';
import {
  comparisonTeamCompetitionOptionsAtom,
  comparisonTeamSeasonOptionsAtom,
} from '@/atoms/filters/team/teamComparisonFilters';
import { comparisonTeamGamesBySeasonAtom } from '@/atoms/queries/team/teamComparisonGames';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';
import { toGameSelectorGroups } from '@/utils/games';

const unwrappedCompetitionOptionsAtom = unwrap(comparisonTeamCompetitionOptionsAtom, prev => prev ?? []);
const unwrappedSeasonOptionsAtom = unwrap(comparisonTeamSeasonOptionsAtom, prev => prev ?? []);
const unwrappedGamesBySeasonAtom = unwrap(comparisonTeamGamesBySeasonAtom, prev => prev ?? []);

const TeamComparisonFiltersContent = ({ comparisonId }: { comparisonId: number }) => {
  const { t } = useTranslation('events');
  const competitionOptions = useAtomValue(unwrappedCompetitionOptionsAtom);
  const seasonOptions = useAtomValue(unwrappedSeasonOptionsAtom);
  const gamesBySeason = useAtomValue(unwrappedGamesBySeasonAtom);
  const gamesGroupedBySeason = toGameSelectorGroups(gamesBySeason);
  const showTracking = usePhysicalMetricsFeature();
  const positionLabels = Object.fromEntries(
    PITCH_POSITION_KEYS.map(key => [key, t(`fields.event.attributes.playerPosition.${key}`)]),
  );

  return (
    <TeamPageFilters
      teamId={comparisonId}
      competitionOptions={competitionOptions}
      seasonOptions={seasonOptions}
      gamesGroupedBySeason={gamesGroupedBySeason}
      positionLabels={positionLabels}
      headerActions={<ResetAllFiltersButton />}
      hidePitch
      hideAttributes
      showTabs={false}
      showTracking={showTracking}
    />
  );
};

export const TeamComparisonHighLevelFilters = () => {
  const comparisonId = useAtomValue(comparisonIdAtom);

  if (!comparisonId) return null;

  return (
    <FilterScopeProvider scope="comparison">
      <TeamComparisonFiltersContent comparisonId={comparisonId} />
    </FilterScopeProvider>
  );
};
